import { isAuthenticated } from "@/business/auth/application/isAuthenticated";
import { loadSession } from "@/business/shared/session/application/loadSession";
import {
  NavigationGuardNext,
  RouteLocationNormalizedGeneric,
} from "vue-router";
import { isSessionActive } from "@/business/shared/session/application/IsSessionActive";
import { getRouteFromLogin } from "@/business/auth/application/getRouteFromLogin";
import { userAuthStore } from "@/business/auth/infrastructure/store/userAuthStore";

export const isAuthenticate = async (
  to: RouteLocationNormalizedGeneric,
  from: RouteLocationNormalizedGeneric,
  next: NavigationGuardNext
) => {
  await loadSession.execute();

  if (isAuthenticated.execute()) {
    next();
  } else {
    next("/login");
  }
};

export const isLoggedAlready = async (
  to: RouteLocationNormalizedGeneric,
  from: RouteLocationNormalizedGeneric,
  next: NavigationGuardNext
) => {
  const isLogged = await isSessionActive.execute();

  if (!isLogged) {
    next();
  } else {
    await loadSession.execute();
    const route = getRouteFromLogin.execute(
      userAuthStore().memoryUserAuth.role
    );
    next(route);
  }
};
